import localforage from 'localforage'

export const storage = localforage
